import { DateTime } from "luxon";

/**
 * Validates if current time is within the allowed trading hours
 * @param timeFrom - Trading start time in HH:mm format (e.g., "08:00")
 * @param timeTo - Trading end time in HH:mm format (e.g., "16:00")
 * @returns true if trading is allowed, false otherwise
 */
const isWithinTradingHours = (
  timeFrom: string | null | undefined,
  timeTo: string | null | undefined,
): boolean => {
  // If no time restrictions are set, trading is always allowed
  if (!timeFrom || !timeTo) {
    return true;
  }

  const now = DateTime.now();

  // Parse trading hours
  const [fromHour, fromMinute] = timeFrom.split(":").map(Number);
  const [toHour, toMinute] = timeTo.split(":").map(Number);

  const tradingStart = now.set({
    hour: fromHour,
    millisecond: 0,
    minute: fromMinute,
    second: 0,
  });

  const tradingEnd = now.set({
    hour: toHour,
    millisecond: 0,
    minute: toMinute,
    second: 0,
  });

  // Check if current time is within the trading window
  return now >= tradingStart && now <= tradingEnd;
};

/**
 * Formats trading hours for display
 * @param timeFrom - Trading start time in HH:mm format
 * @param timeTo - Trading end time in HH:mm format
 * @returns Formatted time range string (e.g., "08:00 - 16:00")
 */
const formatTradingHours = (
  timeFrom: string | null | undefined,
  timeTo: string | null | undefined,
): string | null => {
  if (!timeFrom || !timeTo) {
    return null;
  }

  return `${timeFrom} - ${timeTo}`;
};

export { formatTradingHours, isWithinTradingHours };
